import { Interview_Process, IRequirementMast, Job_Type, Req_Priority, Req_Term, Req_Type } from "../../models/RequirementMast";

export const EmptyRequirement: IRequirementMast = {
    req_ID: 0,
    pV_Contact_PersonID: 0,
    vendor_Company_ID: 0,
    vendor_Company_Name: '',
    client_company: {
        vendor_Company_ID: 0,
        vendor_Company_Name: ''
    },
    req_Job_Title: '',
    req_Duration: '',
    req_City: 0,
    city_Name: '',
    city: {
        city_ID: 0,
        city_Name: ''
    },
    req_State: 0,
    state_Name: '',
    state: {
        state_ID: 0,
        state_Name: ''
    },
    req_Country: 0,
    req_Rate: '',
    req_EndClient: '',
    endClient: {
        end_Client_Id: 0,
        end_Client_Name: ''
    },
    req_Term: Req_Term.Contract,
    req_NoOfPositions: "1",
    req_NoOfResumePerPositions: 2,
    req_Category: 0,
    req_Category_Name: '',
    req_Priority: Req_Priority.High,
    req_isDirectClientRequirement: '',
    req_InterviewProcess: Interview_Process.Telephonic,
    req_RequiredSkill: '',
    req_JobDescription: '',
    req_PostedBySalesManager: 0,
    req_PostedBySalesManager_Name: '',
    req_PostedDateAndTime: undefined,
    req_EditedBy: 0,
    req_EditDateAndTime: undefined,
    req_Hold_UnHoldStatus: false,
    req_Hold_unHoldDateTime: undefined,
    req_AllocatedDateTime: undefined,
    req_Allocated_By: 0,
    req_Service_Status: '',
    req_Publish_Status: '',
    req_ECI_Status: 0,
    req_PO_Status: 0,
    reqType: 0,
    reqType_Name: '',
    travelReq: '0',
    teamName: 0,
    req_Type: Req_Type.Normal,
    job_Type: Job_Type.Onsite,
    req_Sub_Category: 0,
}